module.exports = __webpack_public_path__ + "media/andenes/semaforo_anden-eca12977.webp";